import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import {
  EditTextAssetForArticleGroupMutation,
  EditTextAssetForArticleGroupMutation_editTextAssetForArticleGroup_textAsset,
  EditTextAssetForArticleGroupMutationVariables
} from './__generated__/EditTextAssetForArticleGroupMutation';
import { EDIT_TEXT_ASSET_FOR_ARTICLE_GROUP_MUTATION } from './editTextAssetForArticleGroup.mutation';

type MutationProps = {
  onCompleted?: (textAsset: EditTextAssetForArticleGroupMutation_editTextAssetForArticleGroup_textAsset) => void;
  onError?: (errors: string[]) => void;
};

export const useEditTextAssetForArticleGroup = ({
  onCompleted,
  onError
}: MutationProps): [(variables: EditTextAssetForArticleGroupMutationVariables) => void, { loading: boolean }] => {
  const [mutationFunc, { loading }] = useMutation<
    EditTextAssetForArticleGroupMutation,
    EditTextAssetForArticleGroupMutationVariables
  >(EDIT_TEXT_ASSET_FOR_ARTICLE_GROUP_MUTATION, {
    client: kmsClient,
    onCompleted: (data) => {
      if (data.editTextAssetForArticleGroup?.errors?.length) {
        if (onError) onError(data.editTextAssetForArticleGroup.errors);
      } else {
        if (onCompleted && data.editTextAssetForArticleGroup?.textAsset)
          onCompleted(data.editTextAssetForArticleGroup.textAsset);
      }
    },
    onError: (error) => onError && onError([error.message])
  });

  return [(variables) => mutationFunc({ variables }), { loading }];
};
